import script from "./HouseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseDetails.vue?vue&type=script&setup=true&lang=js"

import "./HouseDetails.vue?vue&type=style&index=0&id=ed501356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed501356"]])

export default __exports__